/** Pure helpers for the monthly report settings card. */

export const REPORT_DAYS = Array.from({ length: 31 }, (_, index) => index + 1);

export const ordinal = (day) => {
  const n = Number(day);
  if (n % 100 >= 11 && n % 100 <= 13) return `${n}th`;
  return `${n}${{ 1: "st", 2: "nd", 3: "rd" }[n % 10] || "th"}`;
};

/** "1 Oct 2026" from the API's ISO date, read as a calendar day (no time zone shift). */
export const formatReportDate = (iso) => {
  if (!iso) return "";
  const [year, month, day] = iso.split("-").map(Number);
  return new Date(Date.UTC(year, month - 1, day)).toLocaleDateString("en-GB", {
    day: "numeric", month: "short", year: "numeric", timeZone: "UTC",
  });
};

/** Days past the 28th do not exist in every month; say what happens then. */
export const shortMonthNote = (day) => (
  Number(day) > 28 ? "In shorter months it arrives on the last day." : ""
);
